const getCenter = (start: number, size: number) => start + size / 2;

export const getCoordsFromElementOrEvent = (
  event: React.MouseEvent,
  element?: Element | null | false
) => {
  if (element) {
    const { x, y, width, height } = element.getBoundingClientRect();
    return { x: getCenter(x, width), y: getCenter(y, height) };
  }
  return { x: event.clientX, y: event.clientY };
};
